export const getChestLevel = (CYCLES, dungeonLevel, cycle) => {
  const cycleData = CYCLES.find((c) => c.id === cycle);
  return cycleData?.chestRewards[dungeonLevel - 1];
};
